import { LessonDao, LessonTypeDao } from '@rock/db-admin';
import type { LessonTypeId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const lessonTypeDao = new LessonTypeDao();
const lessonDao = new LessonDao();

export const lessonTypesState = lessonTypeDao.lessonTypesAtom();

export const lessonTypeState = atomFamily(
    (typeId: LessonTypeId | undefined) => lessonTypeDao.lessonTypeAtom(typeId),
    shallowEqual,
);

/** Which homes actually received this lesson — the "is the evaluation picking it up" question. */
export const lessonsForTypeState = atomFamily(
    (typeId: LessonTypeId | undefined) => lessonDao.lessonsForTypeAtom(typeId),
    shallowEqual,
);
